import { render, staticRenderFns } from "./InputSelect.vue?vue&type=template&id=38f5491d&scoped=true&"
import script from "./InputSelect.vue?vue&type=script&lang=js&"
export * from "./InputSelect.vue?vue&type=script&lang=js&"
import style0 from "./InputSelect.vue?vue&type=style&index=0&id=38f5491d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f5491d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38f5491d')) {
      api.createRecord('38f5491d', component.options)
    } else {
      api.reload('38f5491d', component.options)
    }
    module.hot.accept("./InputSelect.vue?vue&type=template&id=38f5491d&scoped=true&", function () {
      api.rerender('38f5491d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/albert/albertprod/InputSelect.vue"
export default component.exports